import Translate from '@components/Translate';
import useTranslation from '@helpers/useTranslation';
import React, { FC } from 'react';
import { Button, Message } from 'react-bulma-components';
import { SUPPORT_EMAIL } from '../../constants';

type ServerErrorMessageProps = ServerErrorMessageButtonProps | ServerErrorMessageDefaultProps;

interface ServerErrorMessageDefaultProps {
  showResetButton?: never | false;
  onResetClick?: never;
}

interface ServerErrorMessageButtonProps {
  showResetButton: true;
  onResetClick(): void;
}

const ServerErrorMessage: FC<ServerErrorMessageProps> = ({ showResetButton, onResetClick }) => {
  const { t } = useTranslation();

  return (
    <Message color="danger">
      <Message.Body>
        <Translate
          components={{
            br: <br />,
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            email: <a href={`mailto:${SUPPORT_EMAIL}`} />,
            p: <p />,
          }}
          message={t('serverError', { supportEmail: SUPPORT_EMAIL })}
        />
        {showResetButton && (
          <Button color="danger" onClick={onResetClick} mt={4}>
            {t('tryAgain')}
          </Button>
        )}
      </Message.Body>
    </Message>
  );
};

export default ServerErrorMessage;
